























import ExtraButtons from '../../parts/extra_buttons/ExtraButtons.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
import AppInput from '@/uikit/components/AppInput/AppInput.vue';
import { AppPicture } from '@/uikit';
export default {
  components: {
    AppInput,
    AppSvgIcon,
    ExtraButtons,
    AppPicture,
  },
  props: {
    cfg: {
      type: Object as () => LayoutConfig['header']['sections']['userPanel'],
      required: true,
    },
    data: {
      type: Object as () => LayoutDataSet['userPanel'],
      default: () => ({}),
    },
  },
  data() {
    return {
      id: 'user-panel',
    };
  },
  watch: {
    '$route.name'() {
      this.$store.state.menuPanel.menuOpen = false;
      this.$store.state.menuPanel.search = false;
      this.$store.state.menuPanel.searchText = '';
    },
  },
  methods: {
    getValue() {
      return this.$route.query.term ?? '';
    },
    pushRoute(data: any) {
      const { municipality = null } = this.$store.state;
      this.$router.push({
        query: { term: data.target.value, municipality: municipality },
        name: 'search',
      });
    },
  },
  mounted() {
    if (document) {
      let _id = this.id;
      document.addEventListener('click', (event: any) => {
        for (const pathElement of event.composedPath()) {
          if (pathElement.id === _id) {
            return;
          }
        }
        this.$store.state.menuPanel.search = false;
        this.$store.state.menuPanel.menuOpen = false;
      });
    }
  },
  computed: {
    regionName() {
      return this.$store.state.regionProfile.portalTitle;
    },
    regionProfileLogo() {
      return this.$store.state.regionProfile.logoImage || '';
    },
    isMainPage() {
      return this.$route.name === 'start-page';
    },
    blockOpened() {
      if (!this.isMainPage) {
        return true;
      }
      return this.$store.state.menuPanel.menuOpen;
    },
    searchOpened() {
      return this.$store.state.menuPanel.search;
    },
    getStyle() {
      let ret: any = {};
      if (!this.isMainPage) {
        ret['--userPanelPosition'] = 'relative';
      }
      return ret;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/userPanel/UserPanel.vue